import React from "react";
import * as Yup from "yup";
import Form from "@Components/Form";
import { URLS, GRIEVANCE_TYPE_URL, STORAGE_CONSTANT } from "configs/constants";
import { getAssignedModule } from "utils";
// import { useParams } from "react-router-dom";

const initialValues = {
  name: "",
  active: true,
};
const validationSchema = Yup.object({

  name: Yup.string()
    .required("Name is required")
    .typeError("Invalid employee name"),

});

const GrievanceTypeForm = () => {
  // const params = useParams();
  let formFields = [
    {
      type: "input",
      name: "name",
      label: "Name",
      required: true,
      // disabled: `${params.id}` !== "undefined",
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
    {
      type: "reset",
      label: "Reset",
    },
  ];

  let module = getAssignedModule(location.pathname);
  let actionPermission = false;
  if (!module || module === "") {
    actionPermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("change status")) {
        actionPermission = true;
      }
    }
  }
  if (actionPermission) {
    formFields.push({
      type: "switch",
      name: "active",
      label: "Active?",
      required: true,
      nolabel: "No",
      yeslabel: "Yes",
    });
  }

  return (
    <Form
      initialValues={initialValues}
      submitUrl={GRIEVANCE_TYPE_URL}
      listRoute={URLS.GRIEVANCE_TYPE_CUSTOM_FIELDS}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Grievance Type"
      validationSchema={validationSchema}

    />
  );
};

export default GrievanceTypeForm;
